/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { showInfoToast } from "../../../components/CustomToast"
import EtcService from "../../../service/truckcontrol/Etc/etcService"
import { TETCDataPostReq } from "../../../service/truckcontrol/Etc/TEtc"
import { setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import DateInput from "../../../components/InputWrapper/DateInput"
import ZyomuinService from "../../../service/driver/zyomuinService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"

/**
 * ETCデータ手入力モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const EtcRegisterModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  //#region [state]
  const [乗務員ID, set乗務員ID] = useState<number>()
  const [社員コード, set社員コード] = useState<string>()
  const [日付, set日付] = useState<string | null>()
  const [車番, set車番] = useState<string>()
  const [金額, set金額] = useState<number | undefined>(0)
  const [備考, set備考] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    setAlertSource(undefined)
    try {
      const service = new EtcService()

      const reqData: TETCDataPostReq = {
        乗務員ID: 乗務員ID ?? 0,
        日付: 日付 ?? "",
        車番: 車番 ?? "",
        金額: 金額 ?? 0,
        備考,
      }
      const postres = await service.post(reqData)
      dispatch(setAlerts(postres))
      if (postres) {
        showInfoToast(`ETCデータの登録が完了しました`)
        props.setIsEdited(true)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      props.setIsShow(false)
    }
  }

  //#endregion

  //#region [effect]

  const 乗務員取得 = async (社員コード?: string) => {
    if (社員コード == null || 社員コード === "") {
      set乗務員名("")
      return
    }
    try {
      const 社員res = await new ZyomuinService().getList({
        退職フラグ: 0,
        社員コード,
      })

      if (社員res != null && 社員res.data.length > 0) {
        const 社員 = 社員res.data[0]
        // serviceが前方一致でデータ取得しているので、社員コードの一致後に氏名をとる
        if (社員.社員コード === 社員コード && 社員.退職フラグ === 0) {
          set社員コード(社員.社員コード)
          set乗務員ID(社員.乗務員ID)
          set乗務員名(社員.社員氏名)
        }
      } else {
        set乗務員名("")
      }
    } catch (error) {
      dispatch(setAlerts(error))
      set乗務員名("")
    }
  }

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "現金払入力"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <Button
          type="submit"
          variant="waiting"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            beforeSubmit()
          }}>
          登録
        </Button>
      }>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Table className="form-table">
            <tbody>
              <tr>
                <th className="min-w-8rem">日付</th>
                <td>
                  <div style={{ width: "12rem" }}>
                    <DateInput
                      id="日付"
                      value={日付}
                      setValue={(v) => set日付(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">乗務員</th>
                <td>
                  <div className="input-group">
                    <TextInput
                      style={{ width: "6rem" }}
                      id="乗務員"
                      name="乗務員"
                      maxLength={4}
                      value={社員コード}
                      onBlur={async (e) => {
                        // TODO: 単票系のAutoComplete未実装
                        const v = e.currentTarget.value
                        乗務員取得(v)
                      }}
                      setValue={(v) => {
                        set社員コード(v)
                      }}
                    />
                    <button type="button" className="icon-button">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}></FontAwesomeIcon>
                      </a>
                    </button>
                    <TextInput
                      style={{ width: "10rem" }}
                      id="担当乗務員名"
                      name="担当乗務員名"
                      isReadOnly={true}
                      value={乗務員名}
                      setValue={(v) => set乗務員名(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">車番</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <TextInput
                      id="車番"
                      name="車番"
                      value={車番}
                      setValue={(v) => set車番(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">高速料</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="金額"
                      name="金額"
                      format={"n0"}
                      value={金額}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set金額(c.value) : set金額(undefined)
                      }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">備考</th>
                <td>
                  <div style={{ width: "20rem" }}>
                    <TextInput
                      id="備考"
                      name="備考"
                      value={備考}
                      setValue={(v) => set備考(v)}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
      </Container>
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          set社員コード(乗務員.社員コード)
          set乗務員ID(乗務員.乗務員ID)
          set乗務員名(乗務員.社員氏名)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で登録しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default EtcRegisterModal
